import { PROJET_NAME_BODAC } from '@/configuration/imageConnexion';
import HTTP from '../HTTP';

const URL_BASE = 'commun/ImageConnexion/';

export async function getImageConnexion(projetName = PROJET_NAME_BODAC) {
  const response = await HTTP.get(URL_BASE + 'GetImageConnexionAsync', {
    params: { projetName },
  });
  return response;
}

export async function updateImageConnexion(fd) {
  const response = await HTTP.put(URL_BASE + 'UpdateImageConnexionAsync', fd);
  return response;
}

export async function deleteImage(projetName = PROJET_NAME_BODAC) {
  const response = await HTTP.delete(URL_BASE + 'DeleteImageAsync', { params: { projetName } });
  return response;
}
